module.exports = __webpack_public_path__ + "static/feature-dual-weather-seals-traditional-21af728a2f7ce4a53226fcdf8831ad10.png";